import React, { memo } from 'react';
import './Styles.css';
import { useGlobalAddressContext } from '../../../AddressInfo';
import { formatMessage } from '../../../../../../../../Localization/formatMessage';
import Messages from '../../../../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../../../../Enums/PresentationMode';
import { addressReducerTypes } from '../../../Reducer';
import { useGlobalContext } from '../../../../../../../../context/GlobalContext';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@ids/react-button';

const EditCreateViewSetter = () => {
  const { modalMode, setModalMode, addressDispatch, countryList } = useGlobalAddressContext();
  const { legalUnit } = useGlobalContext();

  const getCountryByCountryCodeFromList = (code, list) => {
    return list.find(country => country.code === code);
  };

  return (
    <div className="team-page_address-info_edit-create-container">
      {modalMode === PresentationMode.View && (
        <>
          <Button
            size={ButtonSize.X_SMALL}
            type={ButtonType.TEXT}
            variant={ButtonVariant.QUIET}
            onClick={() => {
              if (modalMode === PresentationMode.View) {
                setModalMode(PresentationMode.Edit);
              }
            }}>
            {formatMessage(Messages.addressInfo_edit)}
          </Button>

          <Button
            size={ButtonSize.X_SMALL}
            type={ButtonType.TEXT}
            variant={ButtonVariant.QUIET}
            onClick={() => {
              if (modalMode === PresentationMode.View) {
                setModalMode(PresentationMode.Add);
                addressDispatch({
                  type: addressReducerTypes.switchToCreateMode,
                  country: getCountryByCountryCodeFromList(legalUnit, countryList),
                });
              }
            }}>
            {formatMessage(Messages.addressInfo_create)}
          </Button>
        </>
      )}
    </div>
  );
};

export default memo(EditCreateViewSetter);
